window.addEventListener('heyflow-screen-view', (event) => {
    // console.log('heyflow screen view:', event.detail);


    const container = document.getElementById("multiple-choice-block-id-b3bd1da7");

    if (container) {
        const firstOption = container.querySelector(".multiple-choice-option-container");

        if (firstOption) {
            const clickableDiv = firstOption.querySelector("div");

            if (clickableDiv) {
                clickableDiv.addEventListener("click", function (event) {
                    event.stopPropagation();
                    event.preventDefault();

                    if (document.getElementById("custom-popup")) return;

                    // Create pop-up overlay
                    const popup = document.createElement("div");
                    popup.id = "custom-popup";
                    popup.style.position = "fixed";
                    popup.style.top = "0";
                    popup.style.left = "0";
                    popup.style.width = "100vw";
                    popup.style.height = "100vh";
                    popup.style.backgroundColor = "rgba(255, 255, 255, 0.6)";
                    popup.style.backdropFilter = "blur(10px)";
                    popup.style.display = "flex";
                    popup.style.justifyContent = "center";
                    popup.style.alignItems = "center";
                    popup.style.zIndex = "10000";

                    // Create pop-up content
                    const popupContent = document.createElement("div");
                    popupContent.style.backgroundColor = "white";
                    popupContent.style.padding = "30px 30px";
                    popupContent.style.borderRadius = "12px";
                    popupContent.style.boxShadow = "0px 6px 15px rgba(0, 0, 0, 0.2)";
                    popupContent.style.textAlign = "center";
                    popupContent.style.fontFamily = "Arial, sans-serif";
                    popupContent.style.position = "relative";
                    popupContent.style.width = "320px";
                    popupContent.style.border = "1px solid #F74850";

                    // Add red heading text
                    const heading = document.createElement("h1");
                    heading.textContent = "Achtung!";
                    heading.style.color = "#F74850";
                    heading.style.fontFamily = "Merriweather, serif";
                    heading.style.fontSize = "24px";
                    heading.style.margin = "0";
                    popupContent.appendChild(heading);

                    // Add black description text
                    const description = document.createElement("p");
                    description.textContent = "Dieses Angebot passt möglicherweise nicht zu Ihnen";
                    description.style.color = "#333";
                    description.style.fontFamily = "Montserrat, sans-serif";
                    description.style.fontSize = "16px";
                    description.style.marginTop = "10px";
                    description.style.lineHeight = "1.5";
                    popupContent.appendChild(description);

                    // Add close button
                    const closeButton = document.createElement("div");
                    closeButton.innerHTML = "&times;";
                    closeButton.style.position = "absolute";
                    closeButton.style.top = "10px";
                    closeButton.style.right = "10px";
                    closeButton.style.cursor = "pointer";
                    closeButton.style.fontSize = "18px";
                    closeButton.style.color = "#F74850";
                    closeButton.style.width = "30px";
                    closeButton.style.height = "30px";
                    closeButton.style.display = "flex";
                    closeButton.style.justifyContent = "center";
                    closeButton.style.alignItems = "center";
                    closeButton.style.borderRadius = "50%";
                    closeButton.style.backgroundColor = "rgba(247, 72, 80, 0.2)";
                    closeButton.addEventListener("click", function () {
                        popup.style.opacity = "0";
                        setTimeout(() => popup.remove(), 300);
                    });

                    popupContent.appendChild(closeButton);
                    popup.appendChild(popupContent);
                    document.body.appendChild(popup);
                });
            }
        }
    }


});
window.addEventListener('heyflow-submit', (event) => {
    // console.log('heyflow submit:', event.detail);
});